import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/arbeitsverdichtung',
		name: 'Arbeitsverdichtung',
		component: () => import(/* webpackChunkName: "arbeitsverdichtung" */ '../views/arbeitsverdichtung.vue')
	},	
	{
		path: '/projekt',
		name: 'Projekt',
		component: () => import(/* webpackChunkName: "projekt" */ '../views/projekt.vue')
	},
	{
		path: '/ergebnisse',
		name: 'Ergebnisse',
		component: () => import(/* webpackChunkName: "ergebnisse" */ '../views/ergebnisse.vue')
	},  
	{
		path: '/registrierung',
		name: 'Registrierung',
		component: () => import(/* webpackChunkName: "registrierung" */ '../views/registrierung.vue')
	},
	{
		path: '/anmeldung',
		name: 'Anmeldung',
		component: () => import(/* webpackChunkName: "anmeldung" */ '../views/anmeldung.vue')
	},
	{
		path: '/profil',
		name: 'Profil',
		component: () => import(/* webpackChunkName: "profil" */ '../views/profil.vue')
	}, 	  
	{
		path: '/fragebogen',
		name: 'Fragebogen',
		meta: {
			requiresAnmeldung: true
		},				
		component: () => import(/* webpackChunkName: "fragebogen" */ '../views/fragebogen.vue'),
		props: true
	},
	{
		path: '/interview',
		name: 'Interview',
		meta: {
			requiresAnmeldung: true
		},				
		component: () => import(/* webpackChunkName: "interview" */ '../views/interview.vue')
	},	
	{
		path: '/auswertung',
		name: 'Auswertung',
		meta: {
			requiresAnmeldung: true
		},				
		component: () => import(/* webpackChunkName: "auswertung" */ '../views/auswertung.vue'),
		props: true
	},   
	{
		path: '/chatbot',
		name: 'Chatbot',
		meta: {
			requiresAnmeldung: true
		},
		component: () => import(/* webpackChunkName: "chatbot" */ '../views/chatbot.vue')
	}, 	
	{
		path: '/box',
		name: 'Verfahrensbox',
		component: () => import(/* webpackChunkName: "box" */ '../views/box.vue'),
		props: true
	}, 
	{
		path: '/ressourcen',
		name: 'Ressourcen',
		component: () => import(/* webpackChunkName: "ressourcen" */ '../views/ressourcen.vue'),
		props: false
	}, 	
	{
		path: '/verfahren/:verfahrenid',
		name: 'Verfahren',
		component: () => import(/* webpackChunkName: "verfahren" */ '../views/verfahren.vue'),
		props: true
	}, 
	{
		path: '/veroeffentlichungen',
		name: 'Veröffentlichungen',
		component: () => import(/* webpackChunkName: "veroeffentlichungen" */ '../views/veroeffentlichungen.vue')
	},   
	{
		path: '/impressum',
		name: 'Impressum',
		// route level code-splitting
		// this generates a separate chunk (impressum.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "impressum" */ '../views/impressum.vue')
	},
	{
		path: '/datenschutz',
		name: 'Datenschutz',
		component: () => import(/* webpackChunkName: "datenschutz" */ '../views/datenschutz.vue')
	},
	{
		path: '/kontakt',
		name: 'Kontakt',
		component: () => import(/* webpackChunkName: "kontakt" */ '../views/kontakt.vue')
	},
	{
		path: '/einladung',
		name: 'Einladung',
		meta: {
			requiresAnmeldung: true
		},
		component: () => import(/* webpackChunkName: "einladung" */ '../views/einladung.vue')
	}	
]

const router = new VueRouter({
	routes
})

import $store from '../store/store.js'
export default router
router.beforeEach((to, from, next) => {
// router.beforeEach((to, next) => {
	if (to.matched.some(record => record.meta.requiresRegistrierung)) {
		if ($store.state.teilnehmer == '') {
			// next({ name: 'Registrierung' });
			router.push({ path: 'Registrierung' });
		} else {
			next();
		}
	} else if (to.matched.some(record => record.meta.requiresAnmeldung)) {
		if ($store.state.teilnehmer == '') {
			// next({ name: 'Anmeldung' });
			router.push({ path: 'Anmeldung' });
		} else {
			next();
		}
	} else {
		next();
	}
})
